export const CLIENT_COLLECTION = "clients"
export const COMPANY_COLLECTION = "companies"
export const RECRUIT_COLLECTION = "recruits"
